import { ItemsGrid } from '@rdrive/plugin-items-grid';
import { CategorySubcategoryList } from '@rdrive/plugin-category-list';
import { TotalAndAssignedCards } from '@rdrive/plugin-total-cards';
import setup from './setup.js';

export default {
  name: 'project-page',
  components: { ItemsGrid, CategorySubcategoryList, TotalAndAssignedCards },
  setup,
};
